module.exports = __webpack_public_path__ + "img/hero-image.1986eda6.png";